exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ResponsibilityView {\n  color: white;\n  border-collapse: collapse;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%); }\n  .ResponsibilityView td {\n    height: 10vh;\n    padding-left: 10px;\n    padding-right: 10px; }\n  .ResponsibilityView .th {\n    font-size: 1em;\n    text-align: center; }\n  .ResponsibilityView .Header {\n    text-align: center;\n    padding-top: 10px;\n    padding-bottom: 40px;\n    font-size: 0.9em; }\n  .ResponsibilityView .Label {\n    font-size: 1.0em;\n    height: 16%;\n    padding-right: 80px; }\n  .ResponsibilityView .Value {\n    height: 16%;\n    font-size: 1.2em; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/ResponsibilityView.scss
// module id = 316
// module chunks = 0